import { render, staticRenderFns } from "./UserProfileRegister.vue?vue&type=template&id=53b489ae"
import script from "./UserProfileRegister.vue?vue&type=script&lang=js"
export * from "./UserProfileRegister.vue?vue&type=script&lang=js"
import style0 from "./UserProfileRegister.vue?vue&type=style&index=0&id=53b489ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports